import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@sisumail/ui/style.css';
import './index.css';
import './lib/env'; // Startup Validation

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </React.StrictMode>
);
